import * as React from 'react'

import { orderBy } from 'lodash'

import { Controls } from 'modules/core/hooks/usePaginatedQuery'

import {
  PickerContainer,
  PickerOption,
} from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager/Picker/StructuredPicker/shared'
import { CostCenterOption } from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager/Picker/hooks/useCostCenterByLegalEntities'

interface Props {
  value?: { id: string; name: string }
  placeholder: string
  options: CostCenterOption[]
  selectedIds: number[]
  controls?: Controls
  onSearchChange?: (search: string) => void
  onChange: (option: CostCenterOption) => void
  loading?: boolean
  readonly?: boolean
}

const WorkplacePicker = ({
  value,
  placeholder,
  options,
  selectedIds: _selectedIds,
  controls,
  onSearchChange,
  onChange,
  loading,
  readonly,
}: Props) => {
  const [open, setOpen] = React.useState(false)

  const handleValueChange = (option: CostCenterOption) => {
    setOpen(false)
    onChange(option)
  }

  // Sort options by name
  const sortedOptions = React.useMemo(() => {
    return orderBy(options, (o) => o.name, ['asc'])
  }, [options])

  const unselectedValue = !value || Number(value.id) < 0

  // Only show as selected if it's the current row's value
  const isOptionSelected = (optionId: string) => {
    return value?.id === optionId
  }

  return (
    <PickerContainer
      open={open}
      readonly={readonly}
      onOpenChange={() => setOpen(!open)}
      disabled={options.length < 1 || !!readonly}
      placeholder={placeholder}
      displayValue={unselectedValue ? undefined : value?.name}
      onSearchChange={onSearchChange}
      loading={loading}
      controls={controls}
      hasOptions={options.length > 0}
    >
      {sortedOptions.map((option) => (
        <PickerOption
          key={option.id}
          option={option}
          isSelected={isOptionSelected(option.id)}
          onSelect={handleValueChange}
        />
      ))}
    </PickerContainer>
  )
}

export default WorkplacePicker
